// Header Search Drawer — expandable search in header
// Keyboard: arrows navigate, Enter selects, Esc closes

(function() {
  var searchToggle = document.getElementById('search-toggle');
  var searchDrawer = document.getElementById('search-drawer');
  var searchInput = document.getElementById('header-search-input');
  var searchResults = document.getElementById('search-results');
  var searchClose = document.getElementById('search-close');
  var activeIndex = -1;

  if (!searchToggle || !searchDrawer || !searchInput || !searchResults || !searchClose) return;

  function openDrawer() {
    searchDrawer.classList.add('is-open');
    searchToggle.setAttribute('aria-expanded', 'true');
    searchInput.focus();
  }

  function closeDrawer() {
    searchDrawer.classList.remove('is-open');
    searchToggle.setAttribute('aria-expanded', 'false');
    activeIndex = -1;
    clearResults();
  }

  function clearResults() {
    searchResults.innerHTML = '';
    activeIndex = -1;
  }

  function renderResults(products) {
    clearResults();
    if (!products || products.length === 0) {
      searchResults.innerHTML = '<li class="header-search__no-results">No products found</li>';
      return;
    }
    products.slice(0, 5).forEach(function(product, i) {
      var li = document.createElement('li');
      li.className = 'header-search__result-item' + (i === 0 ? ' is-active' : '');
      li.dataset.index = i;
      li.innerHTML =
        '<img class="header-search__result-image" src="' + (product.featured_image || '') + '" alt="">' +
        '<div class="header-search__result-info">' +
          '<p class="header-search__result-title">' + product.title + '</p>' +
          '<p class="header-search__result-price">' + formatMoney(Math.round(parseFloat(product.price) * 100)) + '</p>' +
        '</div>';
      li.addEventListener('click', function() {
        window.location.href = '/products/' + product.handle;
      });
      searchResults.appendChild(li);
    });
  }

  function setActive(newIndex) {
    var items = searchResults.querySelectorAll('.header-search__result-item');
    items.forEach(function(item) { item.classList.remove('is-active'); });
    activeIndex = newIndex;
    if (items[activeIndex]) {
      items[activeIndex].classList.add('is-active');
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    }
  }

  var debounceTimer;
  function doSearch(query) {
    clearTimeout(debounceTimer);
    if (!query || query.length < 2) {
      clearResults();
      return;
    }
    debounceTimer = setTimeout(function() {
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5';
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data && data.resources && data.resources.results && data.resources.results.products;
          renderResults(products || []);
        });
    }, 250);
  }

  searchToggle.addEventListener('click', function() {
    if (searchDrawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  searchClose.addEventListener('click', closeDrawer);

  searchInput.addEventListener('input', function() {
    doSearch(searchInput.value.trim());
  });

  document.addEventListener('keydown', function(e) {
    if (!searchDrawer.classList.contains('is-open')) return;
    var items = searchResults.querySelectorAll('.header-search__result-item');

    if (e.key === 'Escape') {
      closeDrawer();
      searchInput.value = '';
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(Math.min(activeIndex + 1, items.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(Math.max(activeIndex - 1, 0));
    } else if (e.key === 'Enter') {
      if (activeIndex >= 0 && items[activeIndex]) {
        e.preventDefault();
        items[activeIndex].click();
      } else {
        var q = searchInput.value.trim();
        if (q) { e.preventDefault(); window.location.href = '/search?q=' + encodeURIComponent(q); }
      }
    }
  });

  document.addEventListener('click', function(e) {
    if (!searchDrawer.contains(e.target) && !searchToggle.contains(e.target)) {
      closeDrawer();
    }
  });

  function formatMoney(cents) {
    var money = cents / 100;
    var fmt = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var formatted = (fmt.indexOf('no_decimals') !== -1) ? String(Math.round(money)) : money.toFixed(2);
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }
})();
